import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { getThemeProps } from 'ravenjs/utils/theme';

const SubNavItem = styled(NavLink)`
    align-items: center;
    background-color: transparent;
    border-bottom-color: transparent;
    border-bottom-style: solid;
    border-bottom-width: 3px;
    color: ${getThemeProps('palette.common.dark')};
    display: flex;
    font-size: 14px;
    height: 100%;
    justify-content: center;
    margin-right: 10px;
    padding: 12px;
    text-decoration: none !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out;
    &:last-of-type {
        margin-right: 0;
    }
    &.active {
        ${getThemeProps('SubNavItem.active')};
    }
    /**
     * Add all of the remaining styles from theme
     */
    ${getThemeProps('SubNavItem.styles')};
`;

export default SubNavItem;
